import * as z from "zod";

export const deleteWorkOrderStation = {
  name: "deleteWorkOrderStation" as const,
  input: z.object({ stationId: z.string() }),
  output: z.object({}),
};
